<div>Classrooms</div>
<ng-container *ngFor="let classroom of classrooms; trackBy: trackByFn">
  <a [routerLink]="classroomRoute(classroom)">➡️ {{ classroom.title }}</a>
</ng-container>

